/**
 * Identidad legal del responsable del tratamiento + datos de contacto.
 *
 * ÚNICO lugar a editar para actualizar ambas páginas legales (/privacy y /terms).
 * Estos datos aparecen públicamente, por eso NO se incluye DNI ni datos personales
 * sensibles: solo la identificación comercial (RUC) y un contacto de soporte.
 */
const LEGAL = {
  // Marca comercial visible del producto (debe coincidir con lo que ve el revisor de Meta).
  brand: "PowerWapp",

  // Titular / responsable del tratamiento (persona natural con negocio, SUNAT Perú).
  operator: "Leopoldo Dante Huacasi Viena",
  tradeName: "KANEGOCIO",
  ruc: "10433275328",

  // Domicilio y contacto (MVP: solo ciudad/país + email de soporte; sin datos personales).
  address: "Lima, Perú",
  city: "Lima",
  country: "Perú",
  email: "hola@todosistemas.online",

  // Dominios del servicio.
  website: "https://watolxapp.todosistemas.online",

  // Fecha de última actualización (mostrada en ambos documentos).
  lastUpdated: "15 de agosto de 2026",
};

export default LEGAL;
